<template>
  <footer class="hkok-footer">
    <div class="main">
      <div class="first-row">
        <img class="logo" src="../assets/images/logo_blue.svg" />
        <div class="contact">
          <span>联系我们：</span>
          <span class="phone-num">400-632-8005</span>
        </div>
      </div>
      <div class="second-row">迪哲教育（控股）有限公司</div>
      <div class="last-row">
        <span>DEGREE EDUCATION (HOLDINGS) LIMITED.</span>
        <!-- <span>内地总部：深圳市福田区华富街道深业上城写字楼B座</span>
				<span>香港总部：香港新界荃湾如心广场19楼</span> -->
        <span
          >联系邮箱：<a href="mailto:info@offerhk.com"
            >info@offerhk.com</a
          ></span
        >
      </div>
    </div>
    <div class="bottom">
      <!-- <span>© 2015-2022. 迪哲教育（控股）有限公司</span>
			<span> DEGREE EDUCATION (HOLDINGS) LIMITED. </span> -->
      <span
        ><a href="https://beian.miit.gov.cn/" target="_blank"
          >粤ICP备18065010号-3</a
        ></span
      >
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped lang="scss">
.hkok-footer {
  background-color: #f3f3f3;

  & .main {
    width: 1279px;
    margin: 0 auto;
    padding-top: 48px;
    padding-bottom: 33px;
    color: #6d6d6d;

    .first-row {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.logo {
        flex-shrink: 0;
      }

      & .contact {
        & > span {
          display: inline-block;
          vertical-align: middle;
        }

        & .phone-num {
          color: #3a8df5;
          font-weight: 700;
          font-size: 28px;
        }
      }
    }

    .second-row {
      line-height: 1;
      margin-top: 36px;
      margin-bottom: 8px;
    }

    .last-row {
      display: flex;
      justify-content: space-between;

      & a {
        color: #6d6d6d;
      }
    }
  }

  & .bottom {
    background-color: #e9e9e9;
    color: #4d4d4d;
    font-size: 14px;
    text-align: center;
    padding: 17px 0;
    line-height: 1;

    & a {
      color: #4d4d4d;
      text-decoration: none;
    }
  }
}
</style>
